import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Android">
                <h1>Android App Development Company in Dubai</h1>
              </div>
              <p className="main_para">
                We are a bespoke Android app development company in Dubai,
                creating customized mobile apps that meet the particular
                requirements of the Dubai market. Delivering flawless user
                experiences across a range of Android devices is our mission as
                experts in Android app development. Work with us now to start a
                superior experience of Android app development in Dubai that
                will advance your company.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
